import { styled } from '@mui/material/styles';
import { up, lightPalette } from '../../../../../theme';

export const classes = {
  root: 'root',
  errorCardComponent: 'errorCardComponent',
  CardComponent: 'CardComponent',
  selectedCardComponent: 'selectedCardComponent',
  selectedTextField: 'selectedTextField',
  CardHeader: 'CardHeader',
  CardContent: 'CardContent',
  GridBox: 'GridBox',
  GridItems: 'GridItems',
  GridItemsTypography: 'GridItemsTypography',
  GridItemTextfield: 'GridItemTextfield',
  Box: 'Box',
  CancelButton: 'CancelButton',
  UpdateButton: 'UpdateButton',
  closeAction: 'closeAction',
  contentCopyIcon: 'contentCopyIcon',
  deleteOutlineIcon: 'deleteOutlineIcon',
  formControl: 'formControl',
};

export const Root = styled('div')(() => ({
  [`&.${classes.root}`]: {
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      width: 0,
    },
  },
  [`& .${classes.errorCardComponent}`]: {
    backgroundColor: lightPalette.secondaryWhite.main,
    borderRadius: '5px',
    [up('xs')]: {
      width: '340px',
      height: '200px',
    },
    [up('sm')]: {
      width: '410px',
      height: '260px',
    },
    [up('md')]: {
      width: '410px',
      height: '290px',
    },
    [up('lg')]: {
      width: '540px',
      height: '280px',
    },
    [up('xl')]: {
      width: '610px',
      height: '345px',
    },
    [up('xxl')]: {
      width: '800px',
      height: '400px',
    },
  },
  [`& .${classes.CardComponent}`]: {
    backgroundColor: lightPalette.secondaryWhite.main,
    borderRadius: '5px',
    [up('xs')]: {
      width: '340px',
      height: '160px',
    },
    [up('sm')]: {
      width: '410px',
      height: '220px',
    },
    [up('md')]: {
      width: '410px',
      height: '250px',
    },
    [up('lg')]: {
      width: '540px',
      height: '260px',
    },
    [up('xl')]: {
      width: '610px',
      height: '320px',
    },
    [up('xxl')]: {
      width: '800px',
      height: '380px',
    },
  },
  [`& .${classes.selectedCardComponent}`]: {
    backgroundColor: lightPalette.secondaryWhite.main,
    borderRadius: '5px',
    [up('xs')]: {
      width: '340px',
      height: '210px',
    },
    [up('sm')]: {
      width: '410px',
      height: '270px',
    },
    [up('md')]: {
      width: '410px',
      height: '310px',
    },
    [up('lg')]: {
      width: '540px',
      height: '320px',
    },
    [up('xl')]: {
      width: '610px',
      height: '390px',
    },
    [up('xxl')]: {
      width: '800px',
      height: '470px',
    },
  },
  [`& .${classes.CardHeader}`]: {
    width: '100%',
    color: lightPalette.darkPurple.main,
    background: lightPalette.japanBlush.main,
    [up('xs')]: {
      height: '40px',
    },
    [up('sm')]: {
      height: '60px',
    },
    [up('md')]: {
      height: '60px',
    },
    [up('lg')]: {
      height: '60px',
    },
    [up('xl')]: {
      height: '80px',
    },
    [up('xxl')]: {
      height: '90px',
    },
  },
  [`& .${classes.CardContent}`]: {
    marginTop: '10px',
    width: '100%',
    [up('xs')]: {
      padding: '6px',
    },
    [up('sm')]: {
      padding: '9px',
    },
    [up('md')]: {
      padding: '14px',
    },
    [up('lg')]: {
      padding: '18px',
    },
    [up('xl')]: {
      padding: '22px',
    },
    [up('xxl')]: {
      padding: '30px',
    },
  },
  [`& .${classes.GridBox}`]: {
    [up('xs')]: {
      marginBottom: '7px',
    },
    [up('sm')]: {
      marginBottom: '9px',
    },
    [up('md')]: {
      marginBottom: '14px',
    },
    [up('lg')]: {
      marginBottom: '18px',
    },
    [up('xl')]: {
      marginBottom: '22px',
    },
    [up('xxl')]: {
      marginBottom: '26px',
    },
  },
  [`& .${classes.GridItems}`]: {
    height: '100%',
    width: '100%',
  },
  [`& .${classes.formControl}`]: {
    overflowY: 'auto',
    maxHeight: '40px',
  },

  [`& .${classes.GridItemsTypography}`]: {
    color: lightPalette.darkPurple.main,
    [up('xs')]: {
      paddingBottom: '3px',
    },
    [up('sm')]: {
      paddingBottom: '4px',
    },
    [up('md')]: {
      paddingBottom: '5px',
    },
    [up('lg')]: {
      paddingBottom: '6px',
    },
    [up('xl')]: {
      paddingBottom: '8px',
    },
    [up('xxl')]: {
      paddingBottom: '10px',
    },
  },
  [`& .${classes.GridItemTextfield}`]: {
    borderColor: lightPalette.darkPurple.lighter,
    borderRadius: '5px',
    '& .MuiInputBase-input': {
      [up('xs')]: {
        height: '6px',
      },
      [up('sm')]: {
        height: '13px',
      },
      [up('md')]: {
        height: '20px',
      },
      [up('lg')]: {
        height: '25px',
      },
      [up('xl')]: {
        height: '30px',
      },
      [up('xxl')]: {
        height: '45px',
      },
    },
  },
  [`& .${classes.selectedTextField}`]: {
    width: '90%',
  },
  [`& .${classes.Box}`]: {
    marginTop: '15px',
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    [up('xs')]: {
      height: '45px',
    },
    [up('sm')]: {
      height: '90px',
    },
    [up('md')]: {
      height: '90px',
    },
    [up('lg')]: {
      height: '67px',
    },
    [up('xl')]: {
      height: '92px',
    },
    [up('xxl')]: {
      height: '130px',
    },
  },
  [`& .${classes.CancelButton}`]: {
    backgroundColor: lightPalette.paperWhite.main,
    color: lightPalette.lunarBase.main,
    marginTop: 0,
    [up('xs')]: {
      width: '80px',
      height: '30px',
      margin: '3px',
    },
    [up('sm')]: {
      width: '99px',
      height: '40px',
      margin: '4px',
    },
    [up('md')]: {
      width: '110px',
      height: '40px',
      margin: '6px',
    },
    [up('lg')]: {
      width: '110px',
      height: '44px',
      margin: '7px',
    },
    [up('xl')]: {
      width: '150px',
      height: '54px',
      margin: '10px',
    },
    [up('xxl')]: {
      width: '150px',
      height: '54px',
      margin: '10px',
    },
  },
  [`& .${classes.UpdateButton}`]: {
    marginTop: 0,
    [up('xs')]: {
      width: '80px',
      height: '30px',
      margin: '3px',
    },
    [up('sm')]: {
      width: '99px',
      height: '40px',
      margin: '4px',
    },
    [up('md')]: {
      width: '110px',
      height: '40px',
      margin: '6px',
    },
    [up('lg')]: {
      width: '110px',
      height: '44px',
      margin: '7px',
    },
    [up('xl')]: {
      width: '150px',
      height: '54px',
      margin: '10px',
    },
    [up('xxl')]: {
      width: '150px',
      height: '54px',
      margin: '10px',
    },
  },
  [`& .${classes.closeAction}`]: {
    cursor: 'pointer',
    width: '20%',
    height: '100%',
  },
  [`& .${classes.contentCopyIcon}`]: {
    marginLeft: '10px',
    cursor: 'pointer',
  },
  [`& .${classes.deleteOutlineIcon}`]: {
    cursor: 'pointer',
    [up('xs')]: {
      width: '18px',
      height: '18px',
    },
    [up('sm')]: {
      width: '19px',
      height: '19px',
    },
    [up('md')]: {
      width: '20px',
      height: '20px',
    },
    [up('lg')]: {
      width: '24px',
      height: '24px',
    },
    [up('xl')]: {
      width: '25px',
      height: '25px',
    },
    [up('xxl')]: {
      width: '28px',
      height: '28px',
    },
  },
}));
